import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { SavePaymentMethod } from "../../types/Types";

type UpdateSavePaymentMethodDto = Partial<SavePaymentMethod>;

export const useSavePayment = (
  options?: UseMutationOptions<
    SavePaymentMethod,
    unknown,
    SavePaymentMethod | UpdateSavePaymentMethodDto,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<SavePaymentMethod>) => {
      if (data.id) {
        return axiosInstance
          .put(getAPIURL(`/Billing/Update`), data)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL("/Billing/Create"), data)
          .then((res) => res.data);
      }
    },
  });
};